<template>
  <f7-page>
    <!-- LOADER BONITO NO BLOQUEANTE -->
    <div v-if="loading" class="preloader-overlay">
      <div class="preloader-card">
        <f7-preloader />
        <div class="preloader-text">{{ $t('loading') }}</div>
      </div>
    </div>
    <div v-if="loaded">
      <FileManager :file-system="fs" />
    </div>
  </f7-page>
</template>

<script>
import { mapActions } from 'vuex';
import FileManager from '@/components/Documentation/FileManager/index.vue';
import { ATCS_ES, NOTIFY_TIME_LONG } from '@/js/constants';
import EventBus from '@/services/event-bus';

export default {
  name: 'EnvironmentDocumentationPage',
  components: {
    FileManager,
  },
  data() {
    return {
      fs: [],
      loaded: false,
      loading: false,
    };
  },
  async beforeMount() {
    this.setCurrentRoute([
      {
        name: this.$t('Environment'),
        disabled: false,
        page: 'EnvironmentSamplesPage',
        active: false,
      },
      {
        name: this.$t('documentation'),
        disabled: true,
        page: 'EnvironmentSamplesPage',
        active: true,
      },
    ]);

    this.setAtc(ATCS_ES.environment);

    try {
      // this.$f7.preloader.show();
      this.loading = true;

      this.fs = await this.getTree(ATCS_ES.environment);
      this.loaded = true;

      // this.$f7.preloader.hide();
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(
              JSON.parse(error.message).error
            )
          ),
          width: 550,
        },
        'error',
        NOTIFY_TIME_LONG
      );
    } finally {
      // this.$f7.preloader.hide();
      this.loading = false;
      this.loaded = true;
    }

    EventBus.$on('EnvironmentDocumentationPage', async () => {
      try {
        this.loaded = false;
        // this.$f7.preloader.show();
        this.loading = true;

        this.fs = await this.getTree(ATCS_ES.agronomy);
        this.loaded = true;

        // this.$f7.preloader.hide();
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(
                JSON.parse(error.message).error
              )
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        // this.$f7.preloader.hide();
        this.loaded = true;
        this.loading = false;
      }
    });
  },
  methods: {
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('documentation', ['setAtc', 'getTree']),
  },
};
</script>
